import React from "react";
import styled from "styled-components";
import { useTheme } from "../../hooks/";
import { Button, StyledText } from "../../components/common/basic";
import { useHistory } from "react-router-dom";
import ComingSoonCard from "./comingSoonCard";
import fariki from "../images/rafiki.png";

const QuoteView = () => {
  const { themeContext, theme } = useTheme();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const history = useHistory();

  return (
    <>
      <OfferHeader>
        <StyledText style={{ fontSize: "18px", fontWeight: "bold" }}>
          Quotes
        </StyledText>
      </OfferHeader>

      <div
        style={{
          marginLeft: 20,
          marginRight: 20,
        }}
      >
        <ComingSoonCard
          imgUrl={fariki}
          mainText="Pulse Motivational"
          subText="Get quotes for positive thinking"
        >
          <Button
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginInline: 15,
              padding: "0 25px",
            }}
            color={background}
            onClick={() => {
              history.push("/pulse_motivational");
            }}
          >
            <StyledText style={{}} color={"white"}>
              Get motivated
            </StyledText>
          </Button>
        </ComingSoonCard>
      </div>
    </>
  );
};

export default QuoteView;

const OfferHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 20px;
`;
